/**
 * @file Popup
 * @author hardylin <hardylin@tencent.com>
 */
import Vue from 'vue'
import Popup from './index.vue'

const PopupConstructor = Vue.extend(Popup)
let instance = new PopupConstructor().$mount()

/**
 * Popup
 * @param {Object} params - 参数对象
 * @param {String} params.title - 标题
 * @param {String} params.content - 内容文本
 * @param {Array} params.options - 选项
 * @param {String} [params.button='确定'] - 按钮文本
 * @param {Object} params.colors - 颜色
 * @returns {Object} Promise 对象
 */
export default function ActionSheetInstance({ title, content, options, button = '确定', colors }) {
    return new Promise((resolve, reject) => {
        instance.title = title.toString()
        instance.content = content.toString()
        instance.options = options
        instance.button = button
        instance.colors = colors
        instance.resolve = resolve
        instance.reject = reject
        instance.show = true
        document.body.appendChild(instance.$el)
    })
}